export default __webpack_public_path__ + "static/media/blue-arrow-round.f73914b6ab713a541769d7e670a16540.svg";